export const isValidEAN13 = code => {
  // O código deve ter exatamente 13 dígitos
  if (!/^\d{13}$/.test(code)) {
    return false;
  }

  // Calcula o dígito de verificação
  const digits = code.split("").map(Number);
  const checkDigit = digits.pop();
  const sum = digits.reduce((acc, digit, index) => {
    return index % 2 === 0 ? acc + digit : acc + digit * 3;
  }, 0);
  const calculatedCheckDigit = (10 - (sum % 10)) % 10;

  return checkDigit === calculatedCheckDigit;
};

export const INVALID_CEAN = ["SEM GTIN", "0", "", "SEMGTIN"];

export const isValidCean = cean =>
  Boolean(cean) && !INVALID_CEAN.includes(String(cean).trim());

export const formatEan = cean => (isValidCean(cean) ? cean : "SEM GTIN");
